/**
 * applicationReadyState — the long-running "app is open" state.
 *
 * Assembled from domain modules. Each module owns its idle.on routing,
 * its state definitions, and any top-level event handlers. The machine
 * stays one machine; this file is the assembly point.
 *
 * Domain split:
 *   notes.ts     — note lifecycle: create, save, open, close, select, fetch, persist, flush
 *   aof.ts       — AOF operations: assign, remove, select, create, rename, delete, merge
 *   notebooks.ts — notebook operations: select, rename, create
 *   settings.ts  — user settings saves
 *   misc.ts      — trash, labels, attachments
 *   ui.ts        — UI toggle/set event handlers (all synchronous assigns)
 */

import { notesIdleOn, notesStates, notesTopLevelOn } from './notes';
import { aofIdleOn, aofStates, aofTopLevelOn } from './aof';
import { notebooksIdleOn, notebooksStates } from './notebooks';
import { settingsIdleOn, settingsStates } from './settings';
import { miscIdleOn, miscStates, miscTopLevelOn } from './misc';
import { uiTopLevelOn } from './ui';

const applicationReadyState = {
  id: 'applicationReady',
  initial: 'idle',
  states: {
    idle: {
      id: 'idle',
      on: {
        ...notesIdleOn,
        ...aofIdleOn,
        ...notebooksIdleOn,
        ...settingsIdleOn,
        ...miscIdleOn,
      },
    },
    ...notesStates,
    ...aofStates,
    ...notebooksStates,
    ...settingsStates,
    ...miscStates,
  },
  on: {
    ...notesTopLevelOn,
    ...aofTopLevelOn,
    ...miscTopLevelOn,
    ...uiTopLevelOn,
  },
};

export default applicationReadyState;
